const path = 'redux/funds';
export const FUNDS_LOADED = `${path}/FUNDS_LOADED`;
export const FUND_LOADED = `${path}/FUND_LOADED`;

